import Vue from 'vue'
import Router from 'vue-router'

import developWord from './modules/file'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  developWord,
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/loginticket',
    component: () => import('@/views/login/loginticket'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    alwaysShow: false,
    hidden: false,
    meta: {
      title: '首页',
      icon: 'component',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [
      {
        path: 'dashboard',
        // component: () => import('@/views/monitor/server'),
        component: () => import('@/views/dashboard/compments/appmanage'),
        name: '首页',
        hidden: false,
        meta: { title: '首页', affix: true }
      }
    ]
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

export const asyncRoutes = [
  {
    path: '/compments',
    component: Layout,
    redirect: '/compments/appmanage',
    children: [
      {
        path: 'appmanage',
        component: () => import('@/views/dashboard/compments/appmanage'),
        name: 'appmanage',
        meta: { title: '应用', icon: 'component', affix: true,
          roles: ['applicationmanagement', 'application', 'admin']
        }
      },
      {
        path: 'appmanagement',
        hidden: true,
        component: () => import('@/views/dashboard/compments/appmanagement'),
        name: 'appmanagement',
        meta: { title: '应用概述',
          roles: ['application']
        }
      },
      {
        path: 'baseinfomatin',
        hidden: true,
        component: () => import('@/views/dashboard/compments/baseinfomatin'),
        name: 'baseinfomatin',
        meta: { title: '基本信息' }
      },
      {
        path: 'jstinfomation',
        hidden: true,
        component: () => import('@/views/dashboard/compments/jstinfomation'),
        name: 'jstinfomation',
        meta: { title: '服务安全' }
      },
      {
        path: 'navbar',
        hidden: true,
        component: () => import('@/views/dashboard/compments/navbar'),
        name: 'navbar',
        meta: { title: '应用概览' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/index',
    alwaysShow: true, // will always show the root menu
    name: 'Permission',
    meta: {
      title: '账号',
      icon: 'peoples',
      roles: [
        'accountmanagement',
        'jibinformation',
        'companyinformation',
        'moneyinfomation',
        'modifyaccount',
        'supgroup'
      ]
    },
    children: [
      {
        path: 'account',
        component: () => import('@/views/userAccount/account/index'),
        name: 'accountmanagement',
        meta: {
          // affix: true ,// 如果设置为true，它则会固定在tags-view中(默认 false)
          roles: ['accountmanagement'],
          icon: 'account',
          title: '账号管理'
        }
      },
      {
        path: 'basic',
        component: () => import('@/views/user/infomation'),
        name: 'jibinformation',
        meta: {
          roles: ['jibinformation'],
          icon: 'basic',
          title: '账户资料'
        }
      },
      {
        path: 'changes',
        name: 'moneyinfomation',
        component: () => import('@/views/userAccount/changes/index'),
        meta: {
          roles: ['moneyinfomation'],
          icon: 'changes',
          title: '修改密码'
        }
      },
      {
        path: 'modify',
        name: 'modifyaccount',
        hidden:true,
        component: () => import('@/views/userAccount/modify/index'),
        meta: {
          roles: ['modifyaccount'],
          icon: 'modify',
          title: '修改账号'
        }
      }
    ]
  },
  {
    path: '/promote',
    component: Layout,
    redirect: '/delegators/index',
    name: 'cooperation',
    meta: {
      roles: ['cooperation', 'Associatedcustomer', 'Invitecode'],
      title: '推广',
      icon: 'guide',
      path: 'associated'
    },
    children: [
      {
        path: 'delegators',
        component: () => import('@/views/promote/delegators/index'),
        name: 'Invitecode',
        meta: {
          icon: 'delegators',
          title: '我的邀请码',
          roles: ['Invitecode']
        }
      },
      {
        path: 'associated',
        component: () => import('@/views/promote/associated/index'),
        name: 'Associatedcustomer',
        meta: {
          icon: 'associated',
          title: '关联客户',
          roles: ['Associatedcustomer']
        }
      }
    ]
  },
  {
    path: '/addUser',
    component: Layout,
    redirect: '/addUser/index',
    alwaysShow: true, // will always show the root menu
    name: 'addUser',
    meta: {
      title: '客户',
      icon: 'user',
      roles: ['theuser', 'administrator', 'admin']
      // roles: ['customer', 'addUser', 'add_user'] // you can set roles in root nav
    },
    children: [
      {
        path: 'addUser',
        component: () => import('@/views/customer/addUser/index'),
        name: 'addUser',
        meta: {
          icon: 'addUser',
          title: '新增客户',
          roles: ['administrator', 'super_admin', 'admin']
        }
      },
      {
        path: 'add_user',
        hidden: true,
        component: () => import('@/views/customer/addUser/add_user'),
        name: 'add_user',
        meta: {
          title: '添加管理员用户'
        }
      }
    ]
  },
  {
    path: '/messageindex',
    component: Layout,
    redirect: '/messageindex/index',
    name: 'message',
    meta: {
      title: '消息',
      icon: 'email',
      roles: ['message', 'messageindex', 'admin']
      // roles: ['admin'] // you can set roles in root nav
    },
    children: [
      {
        path: 'messageindex',
        component: () => import('@/views/message/messageindex/index'),
        name: 'messageindex',
        meta: {
          title: '消息查询',
          icon: 'messageindex',
          roles: ['messageindex']
          // roles: ['admin'] // you can set roles in root nav
        }
      },
      {
        path: 'errormessage',
        component: () => import('@/views/message/errormessage/index'),
        name: 'errormessage',
        meta: {
          icon: 'errormessage',
          roles: ['errormessage'],
          title: '失败消息'
        }
      },
      {
        path: 'testmessage',
        component: () => import('@/views/message/testmessage/index'),
        name: 'testmessage',
        meta: {
          icon: 'testmessage',
          title: '消息发送测试'
        }
      }
    ]
  },
  {
    path: 'http://doc.jxhh.com/help.html',
    name: '帮助',
    component: Layout,
    meta: {
      title: '帮助',
      icon: 'help',
      roles:['help']
    }
  },
  {
    component: Layout,
    name: '选品平台',
    path: 'http://scm.jxhh.com',
    meta: {
      title: '选品',
      icon: 'set',
      roles:['set']
    }
  },
  {
    component: Layout,
    name: '文档',
    path: 'http://doc.jxhh.com/doc/api.html',
    meta: {
      title: '文档',
      icon: 'text',
      roles:['text']
    }
  },
  // 404 page must be placed at the end !!!没有权限的页面直接访问404
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
